export default "__VITE_ASSET__C9XfNwz7__"